export enum GlazingBeadSize {
  OMIT = 'OMIT',
  _34 = '5/8" x 3/4"',
  _12 = '5/8" x 1/2"',
}

export const SteelcraftGlazingBeadSizes = [GlazingBeadSize.OMIT];

export const RepublicGlazingBeadSizes = [GlazingBeadSize.OMIT, GlazingBeadSize._34, GlazingBeadSize._12];
